import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetDescription,
} from '@/components/ui/sheet';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import LeftSidebar from './LeftSidebar.jsx';

const SidebarSheetWrapper = ({ role }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [canOpen, setCanOpen] = useState(true); // New state to control hover-based opening
  // const sidebarRef = useRef(null);

  const handleMouseEnter = useCallback(() => {
    if (canOpen) {
      setIsOpen(true);
    }
  }, [canOpen]);

  // const handleClose = useCallback(() => {
  //   setIsOpen(false);
  //   setCanOpen(false); // Disable hover-based opening temporarily

  //   // Re-enable hover-based opening after a short delay
  //   setTimeout(() => setCanOpen(true), 300);
  // }, []);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <div onMouseEnter={handleMouseEnter} className="inline-block h-full">
        <LeftSidebar isCompact={true} role={role} />
      </div>
      <SheetContent
        side="left"
        className="w-64"
        onPointerEnter={handleMouseEnter}
        hideCloseButton
      >
        <VisuallyHidden>
          <SheetTitle>Navigation Sidebar</SheetTitle>
        </VisuallyHidden>

        <SheetDescription className="sr-only">
          Navigation sidebar for MakerSharks platform
        </SheetDescription>

        {/* Logo and Title Section */}
        <div className="p-1">
          <div className="flex items-center gap-2">
            <Link to="/">
              <img
                className="h-10 w-10"
                src="/blackLogo.svg"
                alt="Makersharks"
              />
            </Link>
            <Link to="/" className="text-[22px] text-center font-semibold">
              MakerSharks
            </Link>
          </div>
        </div>

        {/* Close Button */}
        {/* <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-1 rounded-full bg-gray-200 hover:bg-gray-300 focus:outline-none"
        >
          ✕
        </button> */}

        {/* Sidebar Content */}
        <div className="flex flex-col h-full py-4">
          <LeftSidebar isCompact={false} role={role} />
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default SidebarSheetWrapper;
